import { PathTypes } from './types';

import { SET_PREV_PATH } from './actionTypes';

export const setPrevPathName = (name: string): PathTypes => ({
  type: SET_PREV_PATH,
  prevPathName: name,
});
